import React, { useEffect } from "react";
import { FormattedMessage, IntlShape, useIntl } from "react-intl";
import { RouteComponentProps } from "react-router-dom";

import { UserForm } from "@auth/components/UserForm";
import { User } from "@auth/models";
import { PropsWithId } from "@auth/selectors";
import { messages as authMessages } from "@auth/messages";
import { messages as uiMessages } from "@ui/messages";
import { Page, CardBody, PageTitle, Card } from "@ui/Page";
import { messages } from "@app/messages";
import { setTitle, TitleArgument } from "@app/util";

export interface UsersEditStateProps {
    user: User;
}

export type UsersEditOwnProps = PropsWithId & RouteComponentProps<any>;

type Props = UsersEditOwnProps & UsersEditStateProps;

const updateTitle = (user: User, intl: IntlShape) => {
    const title: TitleArgument[] = [messages.pageUsersTitle];
    if (user != null) {
        title.push(intl.formatMessage(uiMessages.editEntity, {
            entity: user.name,
        }));
    }
    setTitle(intl, ...title);
};

export const UsersEdit = ({ user, history }: Props) => {
    const intl = useIntl();
    useEffect(() => {
        updateTitle(user, intl);
    }, [user]);

    const onSuccess = () => {
        history.push("/users");
    };

    const title = intl.formatMessage(uiMessages.editEntity, {
        entity: intl.formatMessage(authMessages.userEntitySingular),
    });
    const breadcrumbItems = [
        {
            text: <FormattedMessage {...authMessages.userEntityPlural} />,
            to: "/users",
        },
        {
            text: title,
        },
    ];
    return (
        <Page className="users-edit-page" breadcrumbs={breadcrumbItems}>
            <PageTitle tag="h1" className="display-2">{title}</PageTitle>
            <Card>
                <CardBody>
                    <UserForm intl={intl} onSuccess={onSuccess.bind(this)}
                        mode="edit" user={user} />
                </CardBody>
            </Card>
        </Page>
    );
};
